function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import * as React from 'react';
import { notification } from 'antd';
export var simpleNotification = function simpleNotification(method, description, duration, key) {
  var clear = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  if (clear) {
    notification.destroy();
  }
  if (description !== null && _typeof(description) === 'object') {
    if ('message' in description) description = description.message;else if ('error' in description) description = description.error;
  }
  notification[method]({
    key: key,
    className: 'simple-notification',
    message: undefined,
    description: description,
    duration: duration
  });
};
export var simpleFormErrorNotification = function simpleFormErrorNotification(error) {
  var errors = [];
  if ('errorFields' in error) {
    error.errorFields.forEach(function (err) {
      errors.push(err.errors[0]);
    });
  } else {
    Object.keys(error).forEach(function (key) {
      if (error[key].errors) {
        error[key].errors.forEach(function (err) {
          return errors.push(err.message);
        });
      }
    });
  }
  simpleNotification('error', errors.map(function (err) {
    return /*#__PURE__*/React.createElement("div", {
      key: err
    }, err);
  }));
};